import { Toast } from "@aurem/ui";
import { useI18n } from "providers/I18nProvider";
import { gql } from "types";
import { useSafeMutation } from "./useSafeMutation";

const UPDATE_IBAN = gql(/* GraphQL */ `
  mutation UpdateIban(
    $iban: String!
    $employmentId: String
    $productAssignmentId: String
  ) {
    updateIban(
      iban: $iban
      employmentId: $employmentId
      productAssignmentId: $productAssignmentId
    ) {
      id
      iban
    }
  }
`);

export function useUpdateIban() {
  const { t } = useI18n();
  const [updateIban, { loading }] = useSafeMutation(UPDATE_IBAN, {
    onCompleted: () => {
      Toast.success({
        title: t("apps.employee.pages.withdrawals.page.toast.ibanSuccess"),
      });
    },
  });
  return {
    updateIban,
    loading,
  };
}
